import React, { useState } from 'react'
import { SelectBox } from '@tecuity/granite-ui'
import './CustomCorrespondenceOptions.scss'
import { useDispatch } from 'react-redux'
import * as api from 'requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../../SettingsReducer'
import { useSelector, shallowEqual } from 'react-redux'

const ApplicationSettingsOptions = () => {
  const dispatch = useDispatch()
  const { optionalData } = useSelector((state) => state.settings, shallowEqual)

  const [categoryOptions, setCategoryOptions] = useState([{ label: 'All', value: 'All' }])
  const [category, setCategory] = useState(optionalData.category || 'All')

  React.useEffect(() => {
    api.GET_CONFIGURABLE_APP_SETTINGS(
      category,
      (res) => {
        dispatch({
          type: SET_SETTINGS_LIST,
          settingsList: res.map((item) => ({ ...item, Id: item.AppSettingId })),
        })
      },
      (err) => {
        console.error(err)
      }
    )
  }, [category])

  const getCategoryOptions = () => {
    api.GET_CONFIGURABLE_APP_SETTING_CATEGORIES(
      (res) => {
        const options = [
          { label: 'All', value: 'All' },
          ...res.map((t) => ({
            value: t,
            label: t,
          })),
        ]
        setCategoryOptions(options)
      },
      (err) => console.error(err.message)
    )
  }

  React.useEffect(() => {
    getCategoryOptions()
  }, [])

  return (
    <div className="custom-correspondence-options">
      <SelectBox
        label="Category"
        noPlaceholder
        value={category}
        onChange={(val) => {
          setCategory(val)
          dispatch({
            type: SET_OPTIONAL_DATA,
            optionalData: { ...optionalData, category: val },
          })
        }}
        options={categoryOptions}
      />
    </div>
  )
}

export default ApplicationSettingsOptions
